import React, { Component } from 'react';
import LoadingComponent from '../commonComponents/LoadingComponent';
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css'; 

// this component is used when Dropdown have to be used in a Parent Component,independent of forms
class DropdownComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedData: null,
        }

        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
        // jQuery('.selectpicker').selectpicker('render');
        if (this.state.selectedData == null && this.props.async == true) {
            let that = this;
            this.props.asyncHandle(this.props.asyncParams, function (response) {
                that.setState({
                    selectedData: response
                })
            });
        } else {
            // jQuery('.selectpicker').selectpicker('refresh');
        }

    }

    componentDidUpdate(prevProps, nextState) {
        // jQuery('.selectpicker').selectpicker('refresh');
        this.initializeChoices();
    }

    componentDidMount() {
        // jQuery('.selectpicker').selectpicker('refresh');
        this.initializeChoices();

    }
    initializeChoices() {
        const dropdown = document.querySelectorAll('.js-choice');
        dropdown.forEach((selectElement) => {
            new Choices(selectElement, {
                searchEnabled: true,
                shouldSort: false,
                classNames: {
                    containerInner: 'custom-class-for-container',
                    listDropdown: 'custom-class-for-dropdown'
                }
            });
        });
    }
    handleChange(e) {
        this.props.onChange(e, this);
    }

    render() {
        let that = this;
        var optionContent = null;

        // var finalConfig = this.handleDropdownConfig(this.props.dropdownConfig);
        var selectDropdownComponent = <LoadingComponent />;
        var data = null;
        if (this.props.async == true) {
            data = this.state.selectedData;
        } else {
            data = this.props.dropdownData;
        }

        let asyncCheck = (this.props.async !== null && this.props.async !== undefined) ?this.props.async:false;

        let multi = (this.props.multi !== null && this.props.multi !== undefined) ? (this.props.multi?true:null) : null;

        let name = (this.props.label !==null && this.props.label !== undefined)?this.props.label:'name';
        let optionValue = (this.props.optionValue !== null && this.props.optionValue !== undefined) ? this.props.optionValue:'value';

        let dataSize = (this.props.size !== null && this.props.size !== undefined)?this.props.size:10;

        if (data !== null && data !== undefined) {
            if (this.props.custom !== null && this.props.custom !== undefined && this.props.custom) {
                optionContent = this.props.dropdownConfig.optionContent;
            } else {
                optionContent = data.map((element, i) => {
                    return (<option key={`${element[optionValue]}_${i}`} value={element[optionValue]}>{element[name]}</option>);
                });
            }
            let dropdownClass = (that.props.class !== null && that.props.class !== undefined) ? that.props.class : "col-md-12";
            selectDropdownComponent = (
                <select data-dropup-auto="false" multiple={multi} async={asyncCheck} name={that.props.name} data-bs-size={dataSize} id={that.props.id} onChange={this.handleChange} title={that.props.placeholder} className={`js-choice  form-control ${dropdownClass}`} defaultValue={that.props.value} data-style="btn btn-sm btn-white">
                    {optionContent}
                </select>
            );
        } else {
            selectDropdownComponent = null;
        }

        return (
            // <div>
            //     {selectDropdownComponent}
            // </div>
            <div  className="row mb-2">
            <div className="">
                    {selectDropdownComponent}
            </div>
        </div>
        )
    }
}

export default DropdownComponent;